import template from "./create-organization-page.html";

const CreateOrganizationPageComponent = {
  bindings: {
    user: "<",
  },
  template: template,
  controller: class CreateOrganizationPageController {
    /* @ngInject */
    constructor(
      $state,
      $rootScope,
      Notification,
      $filter,
      User,
      SecurityManager,
      SmartVault
    ) {
      this.$state = $state;
      this.$rootScope = $rootScope;
      this.NotificationService = Notification;
      this.$filter = $filter;
      this.User = User;
      this.SecurityManager = SecurityManager;
      this.SmartVault = SmartVault;
    }

    $onInit() {
      this.user = this.$rootScope.user;
      if (this.user.defaultOrganization) {
        this.$state.go("index");
      } else this.syncOrganizations();
    }

    onOrganizationSave(organization) {
      this.$state.go("app.dashboard", { organization: organization.slug });
    }

    async syncOrganizations() {
      this.loading = true;
      this.$rootScope.$applyAsync();
      try {
        this.organizations = await this.SmartVault.syncOrganizations();
        this.canSelectDefaultOrganization = this.organizations.some(
          (organization) => !organization.integrationFailed
        );
      } catch (e) {
        if (e.data === "No valid accounts found") {
          this.noAccountError = true;
        }
      } finally {
        this.loading = false;
        this.$rootScope.$applyAsync();
      }
    }

    async saveDefaultOrganization() {
      await this.User.updateDefaultOrganization(this.user.defaultOrganization);
      await this.SecurityManager.refreshUser();
      this.$state.go("index");
    }

    getRole(organization) {
      return "organizations.role." + organization.getUserRole(this.user.id);
    }
  },
};

export default CreateOrganizationPageComponent;
